import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  DatePicker,
  Menu,
  Select,
  Tag,
  Alert,
  Avatar,
  Spin,
  Row,
  Col,
} from "antd";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Report } from "notiflix";
import "react-big-calendar/lib/css/react-big-calendar.css";
import HeaderFarms from "../../utils/header_farms";
import API from "../../services";
import moment from "moment";
import "./style.css";

import { CheckCircleOutlined } from "@ant-design/icons";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../config/api.config";

import { useLocation } from "react-router-dom";
import { useParams } from "react-router";

const localizer = momentLocalizer(moment);
const { RangePicker } = DatePicker;
const { Option } = Select;

function ScheduleDriver() {
  const [modalDetailBookingVisible, setModalDetailBookingVisible] =
    useState(false);
  const [approvedModalVisible, setApprovedModalVisible] = useState(false);
  const [bookingModalVisible, setBookingModalVisible] = useState(false);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);

  const [selectedNumberPlate, setSelectedNumberPlate] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [defaultDate, setDefaultDate] = useState(null);
  const [targetNode, setTargetNode] = useState(null);
  const [listBooking, setListBooking] = useState([]);
  const [listDriver, setListDriver] = useState([]);
  const [carList, setCarList] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loadingCalendar, setLoadingCalendar] = useState(false);

  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  let { id: id_record } = useParams();
  const location = useLocation();
  const [form] = Form.useForm();

  const isOddDay = currentDate.getDate() % 2 !== 0;

  const handleSelectEventAndOpenModal = (event) => {
    setSelectedEvent(event);
    setModalDetailBookingVisible(true);
  };

  const closeModalDetailBooking = () => {
    setModalDetailBookingVisible(false);
  };

  const handleNavigateDate = async (date) => {
    setCurrentDate(date);
  };

  const goToToday = async () => {
    const today = new Date();
    setCurrentDate(today);
    setDefaultDate(today);
    
    if (selectedNumberPlate) {
      setListBooking([]);
      const request = {
        ...loginRequest,
        account: accounts[0],
      };
      try {
        const responseToken = await instance.acquireTokenSilent(request);
        await loadAndSetListBookingByEvent(responseToken.accessToken, selectedNumberPlate, today);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const jumpToDate = (date) => {
    if (date) {
      setCurrentDate(date.toDate());
      setDefaultDate(date.toDate());
    }
  };

  const openBookingModal = () => {
    if (selectedNumberPlate) setBookingModalVisible(true);
    else
      Report.info(
        "Select Vehicle",
        "Please select a vehicle from the list below.",
        "Okay"
      );
  };

  const closeBookingModal = () => {
    setBookingModalVisible(false);
  };

  const openApproveModal = () => {
    setApprovedModalVisible(true);
  };

  const closeApproveModal = () => {
    setApprovedModalVisible(false);
  };

  const openRejectModal = () => {
    setRejectModalVisible(true);
  };

  const closeRejectModal = () => {
    setRejectModalVisible(false);
  };

  function handleLogin(instance) {
    instance
      .loginRedirect(loginRequest)
      .then(() => { })
      .catch((e) => {
        console.error(e);
      });
  }

  const setSelectedPlateAndGetBookingList = async (e) => {
    const plateNumber = e.key;
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    try {
      const responseToken = await instance.acquireTokenSilent(request);
      loadAndSetListBookingByEvent(responseToken.accessToken, plateNumber);
    } catch (e) {
      console.error(e);
    }

    setSelectedNumberPlate(plateNumber);
    form.setFieldsValue({ plate_number: plateNumber });
  };

  const createBookingDriver = async (data) => {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    try {
      const responseToken = await instance.acquireTokenSilent(request);
      const accessToken = responseToken.accessToken;

      const dateFromString = moment(data.date_from)
        .format("YYYY-MM-DD HH:mm")
        .toString();
      const dateToString = moment(data.date_to)
        .format("YYYY-MM-DD HH:mm")
        .toString();

      data.dateFromString = dateFromString;
      data.dateToString = dateToString;
      data.date_from = moment(data.date_from).toDate();
      data.date_to = moment(data.date_to).toDate();

      await API.CreateBookingDriver(HeaderFarms(accessToken), data);

      await loadAndSetListBookingByEvent(accessToken, selectedNumberPlate, currentDate);

      Report.success(
        `Booking Success`,
        `Please wait for feedback from GA`,
        "Okay"
      );

      closeAllModal();
      form.resetFields();
    } catch (err) {
      closeModalDetailBooking();
      
      const errorMessage = err.response?.data?.error || err.message;
      
      if (errorMessage.includes('Time slot already booked')) {
        Report.warning(
          "Time Slot Not Available",
          "This time slot is already booked. Please select another time.",
          "Okay"
        );
      } else {
        Report.warning(
          "Oops.. something wrong",
          "Sorry, this application is experiencing problems",
          "Okay"
        );
      }
    }
  };

  const handleBookingSubmit = (values) => {
    console.log("Booking details:", values);

    if (checkIsBookingOverlap(values)) return confirmationAndSave(values);
    else
      return Report.info(
        "Car already book with another user",
        "Please select another time.",
        "Okay"
      );
  };

  const approveAndProcess = async () => {
    try {
      console.log(selectedEvent);
      let getDetailProcess = selectedEvent.approval.detail[0]._id;

      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      const response = await instance.acquireTokenSilent(request);

      await API.ApprovalApproved(HeaderFarms(response.accessToken), {
        id: getDetailProcess,
      });

      Report.success(
        `Approved Success`,
        `Berhasil di setujui, Terima Kasih`,
        "Okay",
        async function () {
          closeAllModal();
          const request = { ...loginRequest, account: accounts[0] };
          const responseToken = await instance.acquireTokenSilent(request);
          await loadAndSetListBookingByEvent(responseToken.accessToken, selectedNumberPlate, currentDate);
        }
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const rejectAndProcess = async (values) => {
    try {
      let getDetailProcess = selectedEvent.approval.detail[0]._id;

      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      const response = await instance.acquireTokenSilent(request);

      API.ApprovalReject(HeaderFarms(response.accessToken), {
        id: getDetailProcess,
        reason: values.message,
      });

      Report.success(
        `Reject Success`,
        `Booking Driver berhasil di tolak`,
        "Okay",
        async function () {
          closeAllModal();
          const request = { ...loginRequest, account: accounts[0] };
          const responseToken = await instance.acquireTokenSilent(request);
          await loadAndSetListBookingByEvent(responseToken.accessToken, selectedNumberPlate, currentDate);
        }
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const cancelAndProcess = async (values) => {
    try {
      let getDetailProcess = selectedEvent.approval._id;

      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      const response = await instance.acquireTokenSilent(request);

      API.ApprovalCancel(HeaderFarms(response.accessToken), {
        id: getDetailProcess,
        msg: values.message,
      });

      Report.success(
        `Cancel Success`,
        `Booking Driver berhasil di cancel`,
        "Okay",
        async function () {
          closeAllModal();
          const request = { ...loginRequest, account: accounts[0] };
          const responseToken = await instance.acquireTokenSilent(request);
          await loadAndSetListBookingByEvent(responseToken.accessToken, selectedNumberPlate, currentDate);
        }
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const updateBookingForDispatchDriver = async (values) => {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    try {
      const responseToken = await instance.acquireTokenSilent(request);
      const accessToken = responseToken.accessToken;

      const dateFromString = moment(selectedEvent.start)
        .format("YYYY-MM-DD HH:mm")
        .toString();
      const dateToString = moment(selectedEvent.end)
        .format("YYYY-MM-DD HH:mm")
        .toString();

      await API.UpdateBookingDriver(HeaderFarms(accessToken), {
        driver: values.driver,
        id_record: selectedEvent.id_record,
        message: values.message,
        dateToString,
        dateFromString,
      });

      await loadAndSetListBookingByEvent(accessToken, selectedNumberPlate);

      Report.success(
        `Dispatch driver success`,
        `Driver akan melakukan konfirmasi dengan requestor`,
        "Okay"
      );
    } catch (err) {
      closeModalDetailBooking();
      Report.warning(
        "Oops.. something wrong",
        "Sorry, this application is experiencing problems",
        "Okay"
      );
    }
  };

  const approvedAndUpdateDriver = async (values) => {
    try {
      await approveAndProcess();
      await updateBookingForDispatchDriver(values);

      closeAllModal();
    } catch (err) {
      console.error(err);
      Report.warning(
        "Oops.. something wrong",
        "Sorry, this application is experiencing problems",
        "Okay"
      );
    }
  };

  function closeAllModal() {
    setModalDetailBookingVisible(false);
    setApprovedModalVisible(false);
    setBookingModalVisible(false);
    setRejectModalVisible(false);
  }

  const handleFinishApproved = (values) => {
    Modal.confirm({
      title: "Important Confirmation",
      content: "Are you sure?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        await approvedAndUpdateDriver(values);
      },
    });
  };

  const handleFinishReject = (values) => {
    Modal.confirm({
      title: "Important Confirmation",
      content: "Are you sure?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        if (selectedEvent.status_approve === "Approved")
          await cancelAndProcess(values);
        else await rejectAndProcess(values);
      },
    });
  };

  function customizeFormatBeforeSubmit(values) {
    const [date_from, date_to] = values.date_range;
    values.date_from = moment(date_from.format("YYYY-MM-DD HH"));
    values.date_to = moment(date_to.format("YYYY-MM-DD HH"));
    values.plate_number = selectedNumberPlate;
    delete values.date_range;

    return values;
  }

  function confirmationAndSave(values) {
    Modal.confirm({
      title: "Important Confirmation",
      content: "Are you sure?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          await createBookingDriver(customizeFormatBeforeSubmit(values));
        } catch (error) {
          console.error("onFinish error:", error);

          Report.warning(
            "Ops.. Ada kesalahan pada sistem",
            "Maaf transaksi anda gagal, mohon coba lagi nanti.",
            "Okay"
          );

          closeModalDetailBooking();
        }
      },
    });
  }

  function checkIsBookingOverlap(values) {
    let date_from = values.date_range[0];
    let date_to = values.date_range[1];

    let startTimestamp = moment(date_from).valueOf();
    let endTimestamp = moment(date_to).valueOf();

    // Check if any existing booking overlaps with the new booking
    const hasOverlap = listBooking.some((booking) => {
      let bookingStart = moment(booking.start).valueOf();
      let bookingEnd = moment(booking.end).valueOf();
      
      // Overlap occurs if:
      // new start < existing end AND new end > existing start
      return startTimestamp < bookingEnd && endTimestamp > bookingStart;
    });

    // Return true if NO overlap (can book), false if overlap exists
    return !hasOverlap;
  }

  async function loadDriverListAndSetDriver(token) {
    try {
      let result = await API.getJobPositionTalentaByid(HeaderFarms(token));
      setListDriver(result.data.data);
    } catch (error) {
      console.error("Failed to get driver list:", error);
      throw error;
    }
  }

  async function loadAndSetListBookingByEvent(token, plateNumber, date = currentDate) {
    try {
      setLoadingCalendar(true);
      
      const dateStr = moment(date).format('YYYY-MM-DD');
      console.log('🔍 Loading bookings for:', { plateNumber, dateStr, date });
      
      let result = await API.ListBookingDriverByPlateNumberAndDate(
        HeaderFarms(token),
        plateNumber,
        dateStr
      );

      console.log('📦 Raw API result:', result);
      const filteredBookings = filterByApprovalStatusNotReject(result);
      console.log('✅ Filtered bookings count:', filteredBookings.length, filteredBookings);

      setListBookingAndChangeFormat(filteredBookings);
    } catch (error) {
      console.error("Failed to get and set list booking by event:", error);
      throw error;
    } finally {
      setLoadingCalendar(false);
    }
  }

  function filterByApprovalStatusNotReject(result) {
    if (Array.isArray(result.data)) {
      return result.data.filter(
        (booking) =>
          booking.approval.data.status !== "Reject" &&
          booking.approval.data.status !== "Cancel"
      );
    } else {
      return [];
    }
  }

  async function loadBookingByRecordId(token, id_record) {
    try {
      let result = await API.GetBookingDetail(
        HeaderFarms(token),
        id_record
      );
      return result;
    } catch (error) {
      console.error("Failed to get detail booking by record ID:", error);
      throw error;
    }
  }

  async function openDetailBookingModalByRecordId() {
    console.log('🔍 Checking id_record from URL:', id_record);
    console.log('🔍 selectedNumberPlate:', selectedNumberPlate);
    
    if (id_record && selectedNumberPlate === null) {
      console.log('📥 Loading booking detail...');
      try {
        const bookingDetail = await loadAndSetNumberPlateDetailBookingByRecordId();
        console.log('📦 Booking detail:', bookingDetail);
        
        if (bookingDetail?.data) {
          console.log('✅ Opening modal with data');
          const booking = Array.isArray(bookingDetail.data) ? bookingDetail.data[0] : bookingDetail.data;
          setDefaultDateAndCloseLoading(booking);
          openModalDetailBookingByRecordId(booking);
          setSelectedNumberPlate(booking.plate_number);
        } else {
          console.log('❌ No booking data found');
        }
      } catch (error) {
        console.error('❌ Error loading booking:', error);
      }
    } else {
      console.log('⏭️ Skipping - id_record:', id_record, 'selectedNumberPlate:', selectedNumberPlate);
    }

    console.log('✅ openDetailBookingModalByRecordId completed');
    return setLoading(false);
  }

  function openModalDetailBookingByRecordId(bookingDetail) {
    const result = getChangeFormatEvent(bookingDetail);
    handleSelectEventAndOpenModal(result);
  }

  function setDefaultDateAndCloseLoading(booking) {
    const bookingDate = new Date(booking.date_from);
    setDefaultDate(bookingDate);
    setCurrentDate(bookingDate);
    setLoading(false);
  }

  async function loadAndSetNumberPlateDetailBookingByRecordId() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    try {
      const response = await instance.acquireTokenSilent(request);
      const bookingDetail = await loadBookingByRecordId(
        response.accessToken,
        id_record
      );

      const booking = Array.isArray(bookingDetail?.data) ? bookingDetail.data[0] : bookingDetail.data;
      await setNumberPlateAndSearchByNumberPlate(
        booking.plate_number
      );
      return bookingDetail;
    } catch (e) {
      console.error(e);
    }
  }

  async function setNumberPlateAndSearchByNumberPlate(plateNumber) {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    try {
      const responseToken = await instance.acquireTokenSilent(request);
      loadAndSetListBookingByEvent(responseToken.accessToken, plateNumber);
      setSelectedNumberPlate(plateNumber);
    } catch (e) {
      console.error(e);
    }
  }

  function setListBookingAndChangeFormat(result) {
    const transformedData = result.map((item) => {
      return getChangeFormatEvent(item);
    });

    console.log('Transformed booking data for calendar:', transformedData);
    setListBooking(transformedData);
    setTimeout(() => {
      setLoadingCalendar(false);
    }, 500);
  }

  const eventPropGetter = (event) => {
    let newStyle = {
      border: "1px solid rgba(37, 41, 44, 0.5)",
      backgroundImage: "",
    };

    if (event.approval.status === "Approved") {
      newStyle.backgroundImage = "linear-gradient(to left, #39AC47, #39AC47)";
    } else if (event.approval.status === "Waiting Approval") {
      newStyle.backgroundImage = "linear-gradient(to left, #FF9900, #FF9900)";
    }

    return {
      className: "",
      style: newStyle,
    };
  };

  function getChangeFormatEvent(item) {
    const startDate = new Date(item.date_from);
    const endDate = new Date(item.date_to);
    const timeRange = `${moment(startDate).format("HH:mm")} - ${moment(
      endDate
    ).format("HH:mm")}`;

    const driverDispatch = listDriver.find(
      (driver) => driver.employee_id === item.driver
    );

    let format = {
      title: (
        <>
          <span style={{ fontSize: 13, marginLeft: 7 }}>{item.fullname}</span>
          <br />
          <span
            style={{ fontSize: 12, marginLeft: 7, marginTop: 2 }}
          >{`${item.approval.data.status}`}</span>
          <br />
          <span style={{ fontSize: 12, marginLeft: 7, marginTop:2 }}>
            {timeRange}
          </span>
        </>
      ),
      approval: item.approval.data,
      requestor: item.fullname,
      start: startDate,
      end: endDate,
      start_event: startDate,
      end_event: endDate,
      plate_number: item.plate_number,
      status_approve: item.approval.data.status,
      objective: item.objective,
      destination: item.destination,
      approver: item.approval.data.detail[0].approver.fullname,
      driver: (
        <>
          {driverDispatch?.avatar ? (
            <Avatar
              src={driverDispatch?.avatar || "default-avatar-url"}
              size={50}
              style={{ marginRight: 5 }}
            />
          ) : (
            <Avatar style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}>
              ?
            </Avatar>
          )}
          <span className="ml-2">
            {driverDispatch?.first_name || " Not specified"}
          </span>
        </>
      ),
      id_record: item.id_record,
    };

    return format;
  }

  function customizeButtonToolbar() {
    // Hide default Back/Next buttons, use our filter instead
    const toolbar = document.querySelector(".rbc-toolbar");
    if (toolbar) {
      const btnGroup = toolbar.querySelector(".rbc-btn-group");
      if (btnGroup) {
        btnGroup.style.display = "none";
      }
    }
  }

  function applyCustomTimeSlotStyles() {
    const timeSlotLeftColumn = document.querySelectorAll(
      ".rbc-time-column .rbc-timeslot-group"
    );
    const timeSlotRight = document.querySelector(
      "div.rbc-day-slot.rbc-time-column"
    )?.children;

    timeSlotLeftColumn.forEach((slot, index) => {
      const slotText = slot.innerText.trim();
      const slotTime = moment(slotText, "HH:mm");
      const hour = slotTime.hour();

      if ((hour >= 6 && hour < 10) || (hour >= 16 && hour < 21)) {
        slot.classList.add("red-time-slot");
        timeSlotRight[index].classList.add("red-time-slot");
        timeSlotRight[index].classList.add("watermark");
      }
    });
  }

  const plateMenu = (
    <>
      <Menu
        onClick={setSelectedPlateAndGetBookingList}
        selectedKeys={[selectedNumberPlate]}
      >
        {carList.map((car) => (
          <Menu.Item className="m-0" key={car.plate_number}>
            {selectedNumberPlate === car.plate_number && (
              <CheckCircleOutlined
                className="currentOdd"
                style={{ color: "green" }}
              />
            )}
            {car.plate_number}
            {car.brand && ` - ${car.brand}`}
            {car.model && ` ${car.model}`}
          </Menu.Item>
        ))}
      </Menu>
      {loadingCalendar && (
        <div className="spin-calendar d-flex justify-content-center m-3">
          <Spin size="small" spinning={loadingCalendar} />
        </div>
      )}
    </>
  );

  async function loadListDriver() {
    if (listDriver.length === 0) {
      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      try {
        const response = await instance.acquireTokenSilent(request);
        loadDriverListAndSetDriver(response.accessToken);
      } catch (e) {
        console.error(e);
      }
    }
  }

  async function loadCarList() {
    if (carList.length === 0) {
      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      try {
        const response = await instance.acquireTokenSilent(request);
        const result = await API.ListCar(HeaderFarms(response.accessToken));
        console.log('Car list result:', result);
        setCarList(result.data || []);
      } catch (e) {
        console.error('Failed to load car list:', e);
      }
    }
  }

  function checkOuthentication() {
    if (!isAuthenticated) {
      if (instance.getAllAccounts().length > 0) {
        instance.setActiveAccount(accounts[0]);
      } else {
        handleLogin(instance);
      }
    }
  }

  function setTimeLabelRangePicker() {
    const timePanel = document.querySelector(".ant-picker-time-panel");
    if (timePanel && !timePanel.querySelector(".time-label")) {
      const headerView = timePanel.querySelector(".ant-picker-header-view");
      headerView.innerText = "Time";
    }
  }

  useEffect(() => {
    const node = document.querySelector(".rbc-row-content");
    setTargetNode(node);

    const buttons = document.querySelectorAll(".rbc-btn-group button");
    buttons.forEach((button) => {
      button.classList.add("btn", "btn-primary");
    });

    customizeButtonToolbar();
    applyCustomTimeSlotStyles();
  }, [currentDate, selectedNumberPlate]);

  useEffect(() => {
    checkOuthentication();
    openDetailBookingModalByRecordId();
    loadListDriver();
    loadCarList();
  }, []);

  if (loading) {
    return (
      <Spin
        size="large"
        spinning={loading}
        style={{ display: "flex", justifyContent: "center" }}
      />
    );
  }

  return (
    <>
      <div className="container white-back-cr">
        <div className="mt-2">
          <div className="mb-3">
            <Row gutter={[12, 12]} align="middle" style={{ marginBottom: 16 }}>
              <Col xs={24} md={8} lg={6}>
                <Select
                  placeholder="🚗 Select Car"
                  size="large"
                  style={{ width: '100%' }}
                  value={selectedNumberPlate}
                  onChange={async (value) => {
                    setSelectedNumberPlate(value);
                    form.setFieldsValue({ plate_number: value });
                    setListBooking([]);
                    
                    const request = {
                      ...loginRequest,
                      account: accounts[0],
                    };
                    try {
                      const responseToken = await instance.acquireTokenSilent(request);
                      await loadAndSetListBookingByEvent(responseToken.accessToken, value, currentDate);
                    } catch (e) {
                      console.error(e);
                    }
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  notFoundContent="No cars available"
                >
                  {carList.map((car) => (
                    <Option key={car.plate_number} value={car.plate_number}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>
                          <strong>{car.plate_number}</strong>
                          {car.brand && ` - ${car.brand}`}
                          {car.model && ` ${car.model}`}
                        </span>
                        {/* <Tag color={car.status === 'available' ? 'green' : car.status === 'in_use' ? 'orange' : 'red'} style={{ margin: 0 }}>
                          {car.status === 'available' ? '✓' : car.status === 'in_use' ? '●' : '✕'}
                        </Tag> */}
                      </div>
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col xs={24} md={8} lg={6}>
                <DatePicker 
                  placeholder="Select Date"
                  size="large"
                  onChange={async (date) => {
                    if (date) {
                      const newDate = date.toDate();
                      setCurrentDate(newDate);
                      setDefaultDate(newDate);
                      
                      if (selectedNumberPlate) {
                        setListBooking([]);
                        const request = {
                          ...loginRequest,
                          account: accounts[0],
                        };
                        try {
                          const responseToken = await instance.acquireTokenSilent(request);
                          await loadAndSetListBookingByEvent(responseToken.accessToken, selectedNumberPlate, newDate);
                        } catch (e) {
                          console.error(e);
                        }
                      }
                    }
                  }}
                  format="YYYY-MM-DD"
                  value={currentDate ? moment(currentDate) : null}
                  style={{ width: '100%' }}
                />
              </Col>
              <Col xs={24} md={16} lg={12}>
                <Row gutter={8}>
                  <Col xs={12} sm={8}>
                    <Button size="large" onClick={goToToday} block>
                      Today
                    </Button>
                  </Col>
                  <Col xs={12} sm={16}>
                    <Button 
                      type="primary" 
                      size="large" 
                      onClick={openBookingModal} 
                      disabled={!selectedNumberPlate}
                      block
                    >
                      📅 Booking Now
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {!selectedNumberPlate && (
            <Alert
              message="Please select a car first to view the schedule"
              type="warning"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}
          <Spin className="text-center" spinning={loadingCalendar} tip="Loading calendar...">
            {!loading && selectedNumberPlate && (
              <Calendar
                key={currentDate.toISOString()}
                localizer={localizer}
                events={listBooking}
                toolbar={true}
                startAccessor="start"
                endAccessor="end"
                showMultiDayTimes
                defaultView="day"
                formats={{
                  timeGutterFormat: "HH:mm",
                }}
                views={["day"]}
                date={currentDate}
                onSelectEvent={handleSelectEventAndOpenModal}
                onNavigate={handleNavigateDate}
                eventPropGetter={eventPropGetter}
              />
            )}
          </Spin>
        </div>
      </div>
      <Modal
        title="Detail Booking"
        id="modal_detail"
        visible={modalDetailBookingVisible}
        onCancel={closeModalDetailBooking}
        footer={null}
        transitionName=""
      >
        {selectedEvent && (
          <>
            <div className="container">
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Requestor:</strong>
                </div>
                <div className="col-md-9 col-6">{selectedEvent.requestor}</div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Plate:</strong>
                </div>
                <div className="col-md-9 col-6">
                  {selectedEvent.plate_number} &nbsp;
                  {
                    carList.find(
                      (car) => selectedEvent.plate_number === car.plate_number
                    ) && (
                      <Tag color="blue">
                        {carList.find(
                          (car) => selectedEvent.plate_number === car.plate_number
                        )?.brand}
                      </Tag>
                    )
                  }
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Destination:</strong>
                </div>
                <div className="col-md-9 col-6">
                  {selectedEvent.destination}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Objective:</strong>
                </div>
                <div className="col-md-9 col-6">{selectedEvent.objective}</div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Start:</strong>
                </div>
                <div className="col-md-9 col-6">
                  {moment(selectedEvent.start_event).format("YYYY-MM-DD HH:mm")}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>End:</strong>
                </div>
                <div className="col-md-9 col-6">
                  {moment(selectedEvent.end_event).format("YYYY-MM-DD HH:mm")}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Driver:</strong>
                </div>
                <div className="col-md-9 col-6">{selectedEvent.driver}</div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Status:</strong>
                </div>
                <div className="col-md-9 col-6">
                  <Tag
                    style={{ fontSize: 13 }}
                    color={
                      selectedEvent.status_approve === "Approved"
                        ? "blue"
                        : "gold"
                    }
                  >
                    {selectedEvent.status_approve}
                  </Tag>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 col-4">
                  <strong>Approver :</strong>
                </div>
                <div className="col-md-9 col-6">{selectedEvent.approver}</div>
              </div>

              {selectedEvent.status_approve !== "Approved" &&
                selectedEvent.approval.detail[0].approver.nik ===
                JSON.parse(localStorage.getItem("session_signin")).nik ? (
                <>
                  <div className="row mt-3 text-center">
                    <div className="col-md-12 mt-3">
                      <Button
                        type="primary"
                        onClick={openApproveModal}
                        style={{ marginRight: "10px" }}
                      >
                        Approved
                      </Button>
                      <Button type="danger" onClick={openRejectModal}>
                        Reject
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {selectedEvent.approval.created_by ===
                    JSON.parse(localStorage.getItem("session_signin")).nik && (
                      <div className="row mt-3 text-center">
                        <div className="col-md-12 mt-3">
                          <Button type="danger" onClick={openRejectModal}>
                            Cancel
                          </Button>
                        </div>
                      </div>
                    )}
                </>
              )}
            </div>
          </>
        )}
      </Modal>
      <Modal
        title="Booking Driver"
        visible={bookingModalVisible}
        onCancel={closeBookingModal}
        footer={null}
        id="modal_form"
        transitionName=""
      >
        <Alert
          message="Please check schedule car operational before booking."
          className="mb-3"
          type="info"
          showIcon
        />
        <Form
          layout="vertical"
          onFinish={handleBookingSubmit}
          form={form}
          size="middle"
        >
          <Form.Item label="Selected Car">
            <Input 
              disabled 
              value={
                selectedNumberPlate && carList.find(c => c.plate_number === selectedNumberPlate)
                  ? `${selectedNumberPlate} - ${carList.find(c => c.plate_number === selectedNumberPlate)?.brand || ''} ${carList.find(c => c.plate_number === selectedNumberPlate)?.model || ''}`
                  : selectedNumberPlate
              }
              style={{ fontWeight: 'bold' }}
            />
          </Form.Item>
          <Form.Item name="plate_number" hidden initialValue={selectedNumberPlate}>
            <Input />
          </Form.Item>
          <Form.Item
            name="destination"
            label="Destination"
            rules={[
              { required: true, message: "Please input the destination!" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="objective"
            label="Objective"
            rules={[{ required: true, message: "Please input the objective!" }]}
          >
            <Input />
          </Form.Item>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="date_range"
                label="Date Range"
                rules={[
                  {
                    required: true,
                    message: "Please select the date and time range!",
                  },
                ]}
              >
                <RangePicker
                  onFocus={() => setTimeLabelRangePicker()}
                  showTime={{
                    format: "HH",
                    minuteStep: 60,
                  }}
                  format="YYYY-MM-DD HH"
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Select Driver"
        visible={approvedModalVisible}
        onCancel={closeApproveModal}
        footer={null}
        transitionName=""
        id="approved_booking"
      >
        <Form layout="vertical" onFinish={handleFinishApproved} size="large">
          <Alert
            message="Please check schedule driver before approved."
            className="mb-3"
            type="info"
            showIcon
          />
          <Form.Item
            name="driver"
            label="Drivers"
            rules={[{ required: true, message: "Please select the driver!" }]}
          >
            <Select placeholder="Select Driver">
              {listDriver.map((plate) => (
                <Option key={plate.employee_id} value={plate.employee_id}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      src={plate.avatar}
                      size="default"
                      style={{ marginRight: 8 }}
                    />
                    {plate.fullname}
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Pesan ke driver"
            name="message"
            rules={[
              {
                required: false,
                message: "Please input your Message!",
              },
            ]}
          >
            <Input.TextArea
              showCount
              style={{ height: "150px", width: "100%" }}
            />
          </Form.Item>
          <Form.Item className="text-center">
            <Button size="middle" type="primary" htmlType="submit">
              Approved
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Write the reason"
        footer={null}
        visible={rejectModalVisible}
        onCancel={closeRejectModal}
        transitionName=""
      >
        <Form
          name="basic"
          wrapperCol={{ span: 24 }}
          initialValues={{ remember: true }}
          onFinish={handleFinishReject}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label=""
            name="message"
            rules={[
              {
                required: false,
                message: "Please input your Message!",
              },
            ]}
          >
            <Input.TextArea
              showCount
              style={{ height: "150px", width: "100%" }}
              minLength={10}
            />
          </Form.Item>
          <Form.Item
            className="mt-3"
            wrapperCol={{
              xs: {
                offset: 8,
                span: 18,
              },
              sm: {
                offset: 7,
                span: 18,
              },
              lg: { offset: 8, span: 18 },
            }}
          >
            <Button type="danger" htmlType="submit">
              Reject
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default ScheduleDriver;
